import React, { useEffect } from 'react';
import './PricesSection.css';
import NavBar from '../components/Nav';
import Footer from '../components/footer';

import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';

const PricesSection = () => {

      useEffect(() => {
    // Scroll to the top when the page is loaded
    window.scrollTo(0, 0);
  }, []);
    const getStartServices = [
        { title: 'Federal - (1040)', price: '$39.99' },
        { title: 'Federal - (1040-NR)', price: '$59.99' },
        { title: 'Each State Return', price: '$39.99' },
        { title: 'City Return & County Returns', price: '$39.99' },
        { title: 'FBAR / FATCA', price: '$39.99' },
        { title: 'Schedule C, E, F, H', price: '$119.99' },
        { title: 'ITIN Application', price: '$219.99' },
        { title: 'ITIN Application (Non Resident)', price: '$299.99' },
        { title: 'Amended Return Charges', price: '$149.99' },
        { title: 'Business Incorporation', price: '$249.99' },
        { title: 'MM LLC / Partnership Return (1065)', price: '$249.99' },
        { title: 'S Corporation (1120-S)', price: '$249.99' },
        { title: 'Corporation (1120)', price: '$249.99' },
        { title: 'Estate and Trusts (1041)', price: '$249.99' },
        { title: 'Estate Tax Return (706)', price: '$249.99' },
        { title: 'Gift Tax Return (709)', price: '$249.99' },
        { title: 'Bookkeeping & Accounting', price: '$14.99' },
        { title: 'Half-Time Bookkeeping (80 Hrs)', price: '$11.99/Hr' },
        { title: 'Full-Time Bookkeeping  (160 Hrs)', price: '$9.99/Hr' },
        { title: 'Review Your Books With Our Tax Experts', price: '$149.99' },
        { title: 'Payroll Quarterly & Annual Filing', price: '$49.99' },
        { title: 'File Your 1099 Form', price: '$9.99' },
    ];

    return (
        <div>
            
            <NavBar />
            
            <div className="li-prices-comparison-container">
                <div className="li-prices-comparison-section">
                    <div className="li-comparison-header">
                        <h2>Our Price List</h2>
                    </div>
                    <div className="li-comparison-table">
                        <div className="li-table-header">
                            <div className="li-table-column">Service</div>
                            <div className="li-table-column">Price</div>
                        </div>
                        {getStartServices.map((service, index) => (
                            <div className="li-comparison-row" key={index}>
                                <div className="li-table-column li-service-name">
                                    {service.title}
                                </div>
                                <div className="li-table-column li-price">
                                    {service.price}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Whatsapp />
            <ScrollTop />
            <Footer />
        </div>
    );
};

export default PricesSection;
